<template>
  <section class="lublin-page__section _lighter">
    <div class="lublin-page__section-container">
      <h2 class="lublin-page__section-title">{{ sectionData.title }}</h2>

      <div class="lublin-page__section-content">
        <div class="lublin-page__third-section-list">
          <div
            v-for="(item, index) in sectionData.items"
            :key="index"
            class="lublin-page__third-section-list-item"
          >
            <img
              class="lublin-page__third-section-list-item-image"
              :src="item.icon"
              alt="benefit image"
            >
            <h4 class="lublin-page__third-section-list-item-text">{{ item.item }}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LublinThirdSection',
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
  },
};
</script>
